import { render } from "./ChoiceList.vue?vue&type=template&id=39abb815&scoped=true"
import script from "./ChoiceList.vue?vue&type=script&lang=js"
export * from "./ChoiceList.vue?vue&type=script&lang=js"

import "./ChoiceList.vue?vue&type=style&index=0&id=39abb815&scoped=true&lang=css"
import "./ChoiceList.vue?vue&type=style&index=1&id=39abb815&lang=scss"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39abb815"]])

export default __exports__